// Copyright (c) 2021, Elicenciamento. All rights reserved.

import React, { createContext, useContext, useState } from "react";
import { Snackbar } from "@mui/material";

const SnackbarContext = createContext({
  addAlert: () => {},
});

const SnackbarProvider = ({ children }) => {
  const [message, setMessage] = useState([]);
  const [open, setOpen] = useState(false);
  const nodeRef = React.useRef(null);

  const addAlert = (message) => {
    setOpen(true);
    setMessage(message);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const value = { addAlert };

  return (
    <SnackbarContext.Provider value={value}>
      {children}

      {message && (
        <Snackbar
          itemRef={nodeRef}
          ref={nodeRef}
          open={open}
          autoHideDuration={5000}
          onClose={handleClose}
          message={message}
        />
      )}
    </SnackbarContext.Provider>
  );
};

const useSnackbar = () => useContext(SnackbarContext);

export { SnackbarProvider, useSnackbar };
